import { render, staticRenderFns } from "./lawFirmHonorsDetails.vue?vue&type=template&id=4c01ae2a&scoped=true"
import script from "./lawFirmHonorsDetails.vue?vue&type=script&lang=js"
export * from "./lawFirmHonorsDetails.vue?vue&type=script&lang=js"
import style0 from "./lawFirmHonorsDetails.vue?vue&type=style&index=0&id=4c01ae2a&prod&lang=css"
import style1 from "./lawFirmHonorsDetails.vue?vue&type=style&index=1&id=4c01ae2a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c01ae2a",
  null
  
)

export default component.exports